export const scaled = (n) => `${((n / 1920) * 100).toFixed(2)}vw`;
